import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';


//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import {  setSaveState } from '../../../actions';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';
import FloatPercentFormatInput from '../../../components/float_percent_input_formatter';

//styles:
const styles = theme => ({
    container: {
        width: '95%',
        height: 165,
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        margin: 0,
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#e6e6e6',
        padding: '4px 2px 4px 12px',
        marginBottom: 5,
        borderBottom: '3px solid #b8b8b8',
    },
    headerRowItem: {
        fontSize: 13,
        fontWeight: '700',
        margin: 0,
        width: '50%',
        padding: '0 10px',
    },
    gridRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 11,
        padding: '2px 10px',
        borderBottom: '1px solid #8bc34a',
        "&:last-child": {
            borderBottom: 'none',
            paddingBottom: 3,
            fontWeight: '700',
        },
    },
    rowItem: {
        width: '50%',
        padding: '0 10px',
        fontWeight: '500',
    },
    rtl: {
        textAlign: 'right',
    },
    leftSide: {
        paddingLeft: 10,
    },
    inputsSide: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '60%'
    },
    input: {
        width: 30,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputImporte: {
        textAlign: 'right',
        margin: '4px 5px 4px 2px',
        padding: 0,
        fontSize: 12,
        height: 14,
    },
    lastInput: {
        height: 25,
        fontWeight: '700',
        [`& fieldset`]: {
            borderColor: 'transparent !important',
        },
    },
});

class CumpleanosTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //encuesta, cumpleaños:
            //op. local
            cumplesOp1M: !this.props.otrosDatosCierreDiario.cumplesOp1M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1M,
            cumplesOp1R: !this.props.otrosDatosCierreDiario.cumplesOp1R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1R,
            cumplesOp1B: !this.props.otrosDatosCierreDiario.cumplesOp1B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1B,
            cumplesOp1E: !this.props.otrosDatosCierreDiario.cumplesOp1E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1E,
            //op. personal
            cumplesOp2M: !this.props.otrosDatosCierreDiario.cumplesOp2M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2M,
            cumplesOp2R: !this.props.otrosDatosCierreDiario.cumplesOp2R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2R,
            cumplesOp2B: !this.props.otrosDatosCierreDiario.cumplesOp2B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2B,
            cumplesOp2E: !this.props.otrosDatosCierreDiario.cumplesOp2E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2E,
            // op. comida
            cumplesOp3M: !this.props.otrosDatosCierreDiario.cumplesOp3M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3M,
            cumplesOp3R: !this.props.otrosDatosCierreDiario.cumplesOp3R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3R,
            cumplesOp3B: !this.props.otrosDatosCierreDiario.cumplesOp3B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3B,
            cumplesOp3E: !this.props.otrosDatosCierreDiario.cumplesOp3E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3E,
            // op. precio
            cumplesOp4M: !this.props.otrosDatosCierreDiario.cumplesOp4M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4M,
            cumplesOp4R: !this.props.otrosDatosCierreDiario.cumplesOp4R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4R,
            cumplesOp4B: !this.props.otrosDatosCierreDiario.cumplesOp4B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4B,
            cumplesOp4E: !this.props.otrosDatosCierreDiario.cumplesOp4E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4E,
            // resultado:
            resultadoCumplesPor100: !this.props.otrosDatosCierreDiario.resultadoCumplesPor100 ? 0 : this.props.otrosDatosCierreDiario.resultadoCumplesPor100,

            editing: false

        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //encuesta, cumpleaños:
                //op. local
                cumplesOp1M: !this.props.otrosDatosCierreDiario.cumplesOp1M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1M,
                cumplesOp1R: !this.props.otrosDatosCierreDiario.cumplesOp1R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1R,
                cumplesOp1B: !this.props.otrosDatosCierreDiario.cumplesOp1B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1B,
                cumplesOp1E: !this.props.otrosDatosCierreDiario.cumplesOp1E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp1E,
                //op. personal
                cumplesOp2M: !this.props.otrosDatosCierreDiario.cumplesOp2M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2M,
                cumplesOp2R: !this.props.otrosDatosCierreDiario.cumplesOp2R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2R,
                cumplesOp2B: !this.props.otrosDatosCierreDiario.cumplesOp2B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2B,
                cumplesOp2E: !this.props.otrosDatosCierreDiario.cumplesOp2E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp2E,
                // op. comida
                cumplesOp3M: !this.props.otrosDatosCierreDiario.cumplesOp3M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3M,
                cumplesOp3R: !this.props.otrosDatosCierreDiario.cumplesOp3R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3R,
                cumplesOp3B: !this.props.otrosDatosCierreDiario.cumplesOp3B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3B,
                cumplesOp3E: !this.props.otrosDatosCierreDiario.cumplesOp3E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp3E,
                // op. precio
                cumplesOp4M: !this.props.otrosDatosCierreDiario.cumplesOp4M ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4M,
                cumplesOp4R: !this.props.otrosDatosCierreDiario.cumplesOp4R ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4R,
                cumplesOp4B: !this.props.otrosDatosCierreDiario.cumplesOp4B ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4B,
                cumplesOp4E: !this.props.otrosDatosCierreDiario.cumplesOp4E ? 0 : this.props.otrosDatosCierreDiario.cumplesOp4E,
                // resultado:
                resultadoCumplesPor100: !this.props.otrosDatosCierreDiario.resultadoCumplesPor100 ? 0 : this.props.otrosDatosCierreDiario.resultadoCumplesPor100,

                editing: false

            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value, editing: true });
    };


    onBlur = (event, field) => {

        const value = parseInt(this.state[field])

        this.setState({ ...this.state, [field]: value, editing: false });
        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, value);
    };

    resultadoEncuesta = () => {

        if (this.state.editing) return;

        let resultDB = 0,
            numberOfAnswers = 0;

        const obj = this.state;

        for (const key in obj)
            if (obj[key] !== 0)
                numberOfAnswers += obj[key];

        if (numberOfAnswers)
            resultDB = ((
                ((parseInt(this.state.cumplesOp1M) + parseInt(this.state.cumplesOp2M) + parseInt(this.state.cumplesOp3M) + parseInt(this.state.cumplesOp4M)) * 25) +
                ((parseInt(this.state.cumplesOp1R) + parseInt(this.state.cumplesOp2R) + parseInt(this.state.cumplesOp3R) + parseInt(this.state.cumplesOp4R)) * 50) +
                ((parseInt(this.state.cumplesOp1B) + parseInt(this.state.cumplesOp2B) + parseInt(this.state.cumplesOp3B) + parseInt(this.state.cumplesOp4B)) * 75) +
                ((parseInt(this.state.cumplesOp1E) + parseInt(this.state.cumplesOp2E) + parseInt(this.state.cumplesOp3E) + parseInt(this.state.cumplesOp4E)) * 100)

            ) / numberOfAnswers);

        return resultDB;
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.container}>
                {/* header row */}
                <div className={classes.headerRow}>
                    <h5 className={classes.headerRowItem}>Cumpleaños</h5>
                    <h5 className={`${classes.headerRowItem} ${classes.rtl}`}>M</h5>
                    <h5 className={`${classes.headerRowItem} ${classes.rtl}`}>R</h5>
                    <h5 className={`${classes.headerRowItem} ${classes.rtl}`}>B</h5>
                    <h5 className={`${classes.headerRowItem} ${classes.rtl}`}>MB</h5>
                </div>

                {/* second row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Local</div>
                    <div className={classes.inputsSide}>

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            value={this.state.cumplesOp1M}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp1M')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp1M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp1M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp1R'}
                            value={this.state.cumplesOp1R}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp1R')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp1R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp1R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp1B'}
                            value={this.state.cumplesOp1B}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp1B')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp1B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp1B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp1E'}
                            value={this.state.cumplesOp1E}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp1E')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp1E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp1E') };
                            }}
                        />


                    </div>
                </div>

                {/* third row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Personal</div>

                    <div className={classes.inputsSide}>

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp2M'}
                            value={this.state.cumplesOp2M}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp2M')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp2M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp2M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp2R'}
                            value={this.state.cumplesOp2R}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp2R')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp2R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp2R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp2B'}
                            value={this.state.cumplesOp2B}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp2B')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp2B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp2B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp2E'}
                            value={this.state.cumplesOp2E}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp2E')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp2E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp2E') };
                            }}
                        />

                    </div>
                </div>


                {/* fourth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Comida</div>

                    <div className={classes.inputsSide}>

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp3M'}
                            value={this.state.cumplesOp3M}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp3M')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp3M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp3M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp3R'}
                            value={this.state.cumplesOp3R}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp3R')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp3R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp3R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp3B'}
                            value={this.state.cumplesOp3B}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp3B')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp3B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp3B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp3E'}
                            value={this.state.cumplesOp3E}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp3E')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp3E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp3E') };
                            }}
                        />

                    </div>
                </div>


                {/* fifth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Opinión Precio</div>

                    <div className={classes.inputsSide}>

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp4M'}
                            value={this.state.cumplesOp4M}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp4M')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp4M')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp4M') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp4R'}
                            value={this.state.cumplesOp4R}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp4R')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp4R')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp4R') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp4B'}
                            value={this.state.cumplesOp4B}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp4B')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp4B')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp4B') };
                            }}
                        />

                        <TextField
                            disabled={this.props.isDiaCerrado ? true : false}
                            fullWidth
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                            variant='outlined'
                            id={'cumplesOp4E'}
                            value={this.state.cumplesOp4E}
                            onChange={(event) => this.handleValueChange(event, 'cumplesOp4E')}
                            onBlur={(event) => this.onBlur(event, 'cumplesOp4E')}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cumplesOp4E') };
                            }}
                        />

                    </div>
                </div>


                {/* sixth row */}
                <div className={classes.gridRow}>
                    <div className={classes.leftSide}>Resultado</div>

                    <TextField
                        id={'cumplesOp4E'}
                        disabled
                        fullWidth
                        variant='outlined'
                        className={classes.lastInput}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatPercentFormatInput }}
                        value={this.resultadoEncuesta()}
                    />
                </div>
            </div >
        );
    };
};


CumpleanosTable.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CumpleanosTable));